import React, { FC, ReactNode } from 'react';
import ReactJsPopup from 'reactjs-popup';
import IconCross from '@shared/icons/IconCross';

interface IPopupProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode[];
  width?: string;
  padding?: string;
}

export const Popup: FC<IPopupProps> = ({
  open,
  onClose,
  children,
  width = '1300px',
  padding = '20px',
}) => {
  return (
    <ReactJsPopup
      open={open}
      modal
      nested
      contentStyle={{
        backgroundColor: '#19181B',
        border: 'none',
        width,
        color: '#777777',
        padding,
        textAlign: 'center',
        borderRadius: '10px',
      }}
      onClose={onClose}
    >
      {children}
    </ReactJsPopup>
  );
};

interface IPopupHeaderProps {
  title: string;
  onClose: () => void;
}

export const PopupHeader: FC<IPopupHeaderProps> = ({ title, onClose }) => {
  return (
    <div className="border-b border-solid pb-[15px] border-opacity-10 border-[#959595] relative">
      <div className="flex items-center">
        <span className="ml-[10px] text-[16px] text-[#FFFFFF]">{title}</span>
      </div>
      <div className="absolute right-0 top-0 cursor-pointer" onClick={onClose}>
        <IconCross />
      </div>
      <input type="hidden" />
    </div>
  );
};
